<template>
  <div>
    <button
      class="show-comment"
      @click="showForm[showId] = true"
      v-show="!showForm[showId]"
      v-if="
        (allowComment === true && isLoggedIn && blockCommented === true && user && user.id !== author &&
        ((user.developer && user.developerIds.includes(developer) === false) || user.roleAdmin === true || user.roleUser === true))
        || (isLoggedIn === false && allowComment === true && blockCommented === true)
      "
    >
      <i class="pro-icon-pencil"></i> {{ editLabel }}
    </button>
    <a
      class="show-comment"
      @click="showComment[showId] = true"
      v-show="!showComment[showId]"
      v-if="npaComments.length > 0"
    >
      {{ $t('Показать комментарии') }}
    </a>
    <div class="comment-form">
      <div
        class="comment-field"
        v-show="showForm[showId]"
        v-if="
          (allowComment === true && isLoggedIn && blockCommented === true && user && user.id !== author &&
          ((user.developer && user.developerIds.includes(developer) === false) || user.roleAdmin === true || user.roleUser === true))
          || (isLoggedIn === false && allowComment === true && blockCommented === true)
        "
      >
        <i class="pro-icon-user1"></i>
        <template v-if="isLoggedIn">
          <div class="input-field">
            <v-overlay absolute :value="loadComment">
              <v-progress-circular indeterminate size="64"/>
            </v-overlay>
            <form action="" class="mt-sm-0 mt-5">
              <ckeditor
                v-model="comments[showId]"
                :editor="editor"
                :config="editorConfig"
                :placeholder="$t('Напишите комментарий...')"
              />
<!--              <v-checkbox-->
<!--                v-model="isNpaOffer"-->
<!--                :label="$t('Предложение к проекту НПА')"-->
<!--                hide-details-->
<!--              />-->
              <div class="comment-file" v-if="showFile == true">
                <input
                  id="file"
                  ref="file"
                  type="file"
                  class="hide"
                  @change="handleFileUpload"
                />
                <a class="attach-file-link" @click="changeFile">{{ $t('Прикрепите файл') }}</a>
                <div v-if="fileName">{{ fileName }} <span class="pro-icon-close" @click="deleteFile"></span></div>
                <div style="color: darkred;" class="file-link" v-if="fileError">{{ fileError }}</div>
              </div>
              <div style="display: flex; flex-direction: row-reverse" class="pt-2">
                <span
                  @click="addComment(comments[showId])"
                  class="btn btn-default send-comment-btn"
                  style="cursor: pointer;"
                >{{ $t('Отправить') }}</span>
              </div>
            </form>
            <button
              @click="addComment(comments[showId])"
              class="btn-send hidden-md-and-down"
              style="display: block"
            ></button>
          </div>
        </template>

        <template v-else>
          <span>
            {{ $t('Чтобы оставить комментарий необходимо') }}
            <router-link active-class="active" :to="$i18nRoute({ name: 'login' })">
              {{ $t('авторизоваться') }}
            </router-link>
            {{ $t('или') }}
            <router-link active-class="active" :to="$i18nRoute({ name: 'register' })">
              {{ $t('зарегистрироваться') }}
            </router-link>
          </span>
        </template>
        <a @click="showForm[showId] = false" class="hide-comment hide-form">
          {{ $t('Скрыть форму комментирования') }}
        </a>
      </div>
      <div
        class="comment-list"
        v-show="showComment[showId]"
        v-if="npaComments.length > 0"
      >
        <div
          class="comment-item"
          v-for="{ comment, commentAnswers } in npaComments"
          :key="comment.id"
          :id="showId + '_' + comment.id"
        >
          <div class="comment-head">
            <template v-if="comment.author.photo">
              <v-avatar>
                <img
                  :src="baseUrl + comment.author.fullFilesDirectory"
                  alt=""
                />
              </v-avatar>
            </template>
            <template v-else>
              <i class="pro-icon-user1"></i>
            </template>
            <label>
              <template v-if="comment.author.nick_name">
                <b>{{ comment.author.nick_name }}:</b>
              </template>
              <template v-else>
                <b>
                  {{ comment.author.second_name }}
                  {{ comment.author.first_name }}:
                </b>
              </template>
              <div v-html="comment.text" :style="expandedComments[comment.id] ? '' : 'max-height: 80px; overflow: hidden;'"></div>
              <a href="#!" class="btn-collapse" v-if="comment.text.length > 280" @click.prevent="toggleExpand(comment)">
                {{ expandedComments[comment.id] ? 'Свернуть' : 'Далее' }}
              </a>
              <a
                v-if="comment.file"
                :href="baseUrl + comment.fullFilesDirectory"
                target="_blank"
                class="file-link"
              >
                {{ $t('Приложенный файл') }}
              </a>
            </label>
            <template
              v-if="
                isLoggedIn &&
                user &&
                comment.author.id == user.id &&
                commentAnswers.length === 0 &&
                editComment
              "
            >
              <div class="">
                <a @click.prevent="showEditComment(comment.id)">
                  {{ editCommentForm[comment.id] === true ? $t('Скрыть форму редактирования') : $t('Редактировать') }}
                </a>
                <a v-if="comment.file"  @click.prevent="deleteCommentFile(comment.id)">
                  {{ $t('Удалить файл') }}
                </a>
                <div class="input-field" v-show="editCommentForm[comment.id]">
                  <v-overlay absolute :value="loadComment">
                    <v-progress-circular indeterminate size="64"/>
                  </v-overlay>
                  <ckeditor
                    v-model="editComments[comment.id]"
                    :editor="editor"
                    :config="editorConfig"
                    @ready="prefill(comment.id, comment.text)"
                    @change="prefill(comment.id, editComments[comment.id])"
                  />
<!--                  <v-checkbox-->
<!--                    v-model="editIsNpaOffer[comment.id]"-->
<!--                    :label="$t('Предложение к проекту НПА')"-->
<!--                    hide-details-->
<!--                    class="mt-2"-->
<!--                    @change="updateEditIsNpaOffer(comment.id, $event)"-->
<!--                  />-->
                  <div class="comment-file" v-if="showFile == true">
                    <input
                      :id="'file'+comment.id"
                      :data-key="comment.id"
                      ref="editFile"
                      type="file"
                      class="hide"
                      @change="handleEditFileUpload(comment.id)"
                    />
                    <a @click="changeEditFile(comment.id)">{{ $t('Прикрепите файл') }}</a>
                    <div v-if="editFileName[comment.id]">{{ editFileName[comment.id] }} <span class="pro-icon-close" @click="deleteEditFile(comment.id)"></span></div>
                  </div>
                  <button
                    @click="saveComment(comment.id, editComments[comment.id])"
                    class="btn-send"
                    style="display: block"
                  ></button>
                </div>
              </div>
            </template>
          </div>
          <div class="comment-ananlytic">
            <div class="date">
              {{ new Date(comment.date) | dateFormat('DD.MM.YYYY HH:mm') }}
              <span v-if="comment.update_date !== null">
                {{ $t('Изменен автором') }} {{ new Date(comment.update_date) | dateFormat('DD.MM.YYYY HH:mm') }}
              </span>
            </div>
            <div class="comment-actions">
              <ul>
                <li>
                  <template
                    v-if="
                      commentVoting === true &&
                        isLoggedIn &&
                        user &&
                        user.id !== author &&
                        ((user.developer && user.developerIds.includes(developer) === false) ||
                          user.roleAdmin === true ||
                          user.roleUser === true) &&
                        comment.author.id != user.id
                    "
                  >
                    <a @click="like(comment, true)">
                      <i class="pro-icon-like"></i>{{ $t('Поддерживаю') }}
                      <span>
                        ({{
                          comment.npa_comment_voices_like !== null
                            ? comment.npa_comment_voices_like.length
                            : 0
                        }})
                      </span>
                    </a>
                  </template>
                  <template v-else-if="!isLoggedIn">
                    <a @click="showCommentNotice(comment.id)">
                      <i class="pro-icon-like"></i>{{ $t('Поддерживаю') }}
                      <span>
                        ({{
                          comment.npa_comment_voices_like !== null
                            ? comment.npa_comment_voices_like.length
                            : 0
                        }})
                      </span>
                    </a>
                  </template>
                  <template v-else>
                    <i class="pro-icon-like"></i>{{ $t('Поддерживаю') }}
                    <span>
                      ({{
                        comment.npa_comment_voices_like !== null
                          ? comment.npa_comment_voices_like.length
                          : 0
                      }})
                    </span>
                  </template>
                </li>
                <li>
                  <template
                    v-if="
                      commentVoting === true &&
                        isLoggedIn &&
                        user &&
                        user.id !== author &&
                        ((user.developer && user.developerIds.includes(developer) === false) ||
                          user.roleAdmin === true ||
                          user.roleUser === true) &&
                        comment.author.id != user.id
                    "
                  >
                    <a @click="like(comment, false)">
                      <i class="pro-icon-dislike"></i>{{ $t('Не поддерживаю') }}
                      <span>
                        ({{
                          comment.npa_comment_voices_dis_like !== null
                            ? comment.npa_comment_voices_dis_like.length
                            : 0
                        }})
                      </span>
                    </a>
                  </template>
                  <template v-else-if="!isLoggedIn">
                    <a @click="showCommentNotice(comment.id)">
                      <i class="pro-icon-dislike"></i>{{ $t('Не поддерживаю') }}
                      <span>
                        ({{
                          comment.npa_comment_voices_dis_like !== null
                            ? comment.npa_comment_voices_dis_like.length
                            : 0
                        }})
                      </span>
                    </a>
                  </template>
                  <template v-else>
                    <i class="pro-icon-dislike"></i>{{ $t('Не поддерживаю') }}
                    <span>
                      ({{
                        comment.npa_comment_voices_dis_like !== null
                          ? comment.npa_comment_voices_dis_like.length
                          : 0
                      }})
                    </span>
                  </template>
                </li>
                <li>
                  <template
                    v-if="
                      commentVoting === true &&
                        isLoggedIn &&
                        user &&
                        user.id !== author &&
                        ((user.developer && user.developerIds.includes(developer) === false) ||
                          user.roleAdmin === true ||
                          user.roleUser === true) &&
                        comment.author.id != user.id
                    "
                  >
                    <v-menu
                      v-model="menu[comment.id]"
                      :close-on-content-click="false"
                      offset-y
                      class="complaint"
                    >
                      <template v-slot:activator="{ on }">
                        <a v-on="on">
                          <i class="pro-icon-warning"></i>{{ $t('Пожаловаться') }}
                        </a>
                      </template>
                      <v-textarea
                        outlined
                        auto-grow
                        rounded
                        rows="1"
                        placeholder="Текст жалобы..."
                        v-model="complaint[comment.id]"
                        full-width
                        class="complaint-form-text"
                      />
                      <button
                        @click="sendComplaint(comment.id)"
                        class="btn-send"
                        style="display: block"
                      ></button>
                    </v-menu>
                  </template>
                  <template v-else-if="!isLoggedIn">
                    <a @click="showCommentNotice(comment.id)">
                      <i class="pro-icon-warning"></i>{{ $t('Пожаловаться') }}
                    </a>
                  </template>
                </li>
              </ul>
              <div class="comment-field hide" :ref="'commentNotice_'+comment.id">
                <span>
                  {{ $t('Чтобы проголосовать/пожаловаться необходимо') }}
                  <router-link active-class="active" :to="$i18nRoute({ name: 'login' })">
                    {{ $t('авторизоваться') }}
                  </router-link>
                  {{ $t('или') }}
                  <router-link active-class="active" :to="$i18nRoute({ name: 'register' })">
                    {{ $t('зарегистрироваться') }}
                  </router-link>
                </span>
                <a @click="showCommentNotice(comment.id, false)" class="hide-comment hide-form">
                  {{ $t('Скрыть') }}
                </a>
              </div>
            </div>
          </div>
          <div
            class="comment-status"
            v-if="
              isLoggedIn &&
                user &&
                (user.id === author ||
                  (user.developer && user.developerIds.includes(developer) === true && user.roleDeveloper === true) ||
                  user.roleAdmin === true)
            "
          >
            Статус: {{ comment.status.transName }}
          </div>
          <div class="comment-control-list"
               v-if="
              isLoggedIn &&
                user &&
                (user.id === author ||
                  (user.developer && user.developerIds.includes(developer) === true && user.roleDeveloper === true) ||
                  user.roleAdmin === true)
            "
          >
            <ul>
              <li
                v-if="
                  comment.status.id === hiddenCommentStatusId ||
                    comment.status.id === hiddenByComplaintCommentStatusId ||
                    comment.status.id === moderationCommentStatusId
                "
              >
                <a
                  @click.prevent="
                    updateCommentStatus(comment.id, publicCommentStatusId)
                  "
                >
                  {{ $t('Опубликовать') }}
                </a>
              </li>
              <li
                v-if="
                  comment.status.id === publicCommentStatusId ||
                    comment.status.id === hiddenByComplaintCommentStatusId ||
                    comment.status.id === moderationCommentStatusId
                "
              >
                <a
                  @click.prevent="
                    updateCommentStatus(comment.id, hiddenCommentStatusId)
                  "
                >
                  {{ $t('Скрыть с публикации') }}
                </a>
              </li>
              <li
                v-if="
                  comment.status.id === publicCommentStatusId ||
                    comment.status.id === hiddenCommentStatusId ||
                    comment.status.id === moderationCommentStatusId
                "
              >
                <a
                  @click.prevent="
                    updateCommentStatus(
                      comment.id,
                      hiddenByComplaintCommentStatusId
                    )
                  "
                >
                  {{ $t('Скрыть с публикации по жалобе') }}
                </a>
              </li>
              <li
                v-if="
                  comment.status.id === hiddenCommentStatusId ||
                    comment.status.id === hiddenByComplaintCommentStatusId ||
                    comment.status.id === moderationCommentStatusId ||
                    comment.status.id === publicCommentStatusId
                "
              >
                <a
                  @click.prevent="
                    updateCommentStatus(comment.id, deleteCommentStatusId)
                  "
                  class="btn-cancel-link"
                >
                  {{ $t('Удалить') }}
                </a>
              </li>
            </ul>
          </div>
          <NpaAnswers
            :commentAnswers="commentAnswers"
            :comment="comment"
            :allowCommentAnswer="allowCommentAnswer"
            :secondAllowCommentAnswer="secondAllowCommentAnswer"
            :author="author"
            :developer="developer"
          />
        </div>
        <template v-if="npaComments.length > 0">
          <a @click="showComment[showId] = false" class="hide-comment">
            {{ $t('Скрыть комментарии') }}
          </a>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Search from '@/model/search'
import NpaAnswers from '@/components/npa/NpaAnswers'
import { Trans } from "@/plugins/Translation"
// ckeditor
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor'
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials'
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold'
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic'
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph'
import HeadingPlugin from '@ckeditor/ckeditor5-heading/src/heading'

export default {
  components: {
    NpaAnswers
  },
  props: {
    npaComments: Array,
    showId: String,
    npaData: Object,
    editLabel: String,
    showFile: Boolean,
    getComment: Boolean,
    allowComment: Boolean,
    commentVoting: Boolean,
    allowCommentAnswer: Boolean,
    secondAllowCommentAnswer: Boolean,
    author: Number,
    developer: Number,
    blockCommented: Boolean,
    editComment: Boolean
  },
  data() {
    return {
      editor: ClassicEditor,
      query: null,
      currentComments: this.npaComments,
      editComments: Array,
      comments: Array,
      complaint: Array,
      menu: {},
      editCommentForm: {},
      showComment: {},
      showForm: {},
      loadComment: false,
      file: '',
      // isNpaOffer: false,
      // editIsNpaOffer: [],
      baseUrl: process.env.VUE_APP_BACK_URL,
      fileName: '',
      fileError: null,
      allowedTypes: [
        'application/pdf',
        'application/x-pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/acrobat',
        'applications/vnd.pdf',
        'text/pdf',
        'text/x-pdf',
        'image/bmp',
        'image/gif',
        'image/jpeg',
        'image/x-icon',
        'image/png',
        'image/pjpeg',
        'image/svg+xml',
        'image/tiff',
        'image/vnd.microsoft.icon',
      ],
      maxFileSize: 50 * 1024 * 1024,
      editFileName: [],
      editFile: [],
      expandedComments: {},
      editorConfig: {
        plugins: [
          EssentialsPlugin,
          BoldPlugin,
          ItalicPlugin,
          ParagraphPlugin,
          HeadingPlugin,
        ],
        toolbar: [
          'heading',
          '|',
          'bold',
          'italic',
          '|',
          'undo',
          'redo',
        ],
        heading: {
          options: [
            {
              model: 'paragraph',
              title: 'Paragraph',
              class: 'ck-heading_paragraph'
            },
            {
              model: 'heading1',
              view: 'h1',
              title: 'Heading 1',
              class: 'ck-heading_heading1'
            },
            {
              model: 'heading2',
              view: 'h2',
              title: 'Heading 2',
              class: 'ck-heading_heading2'
            },
            {
              model: 'heading3',
              view: 'h3',
              title: 'Heading 3',
              class: 'ck-heading_heading3'
            }
          ]
        }
      },
    }
  },
  computed: {
    user() {
      return this.$store.state.getNpaData.currentUser
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn
    },
    publicCommentStatusId() {
      return this.$store.state.getNpaData.publicCommentStatusId
    },
    hiddenCommentStatusId() {
      return this.$store.state.getNpaData.hiddenCommentStatusId
    },
    hiddenByComplaintCommentStatusId() {
      return this.$store.state.getNpaData.hiddenByComplaintCommentStatusId
    },
    moderationCommentStatusId() {
      return this.$store.state.getNpaData.moderationCommentStatusId
    },
    deleteCommentStatusId() {
      return this.$store.state.getNpaData.deleteCommentStatusId
    }
  },
  mounted() {
    let self = this
    this.$set(this.showComment, this.showId, true)
    this.$set(this.showForm, this.showId, false)

    this.npaComments.forEach(function (comment) {
      self.$set(self.menu, comment.comment.id, false)
      self.$set(self.editCommentForm, comment.comment.id, false)
    })
    this.$nextTick(function () {
      this.query = this.$route.query
      if (this.query.answer) return

      if (this.getComment && this.query.comment) {
        this.scrollComment()
      }
    })
  },
  methods: {
    toggleExpand(comment) {
      this.$set(this.expandedComments, comment.id, !this.expandedComments[comment.id]);
    },
    addComment(comment) {
      if (!comment) {
        return
      }
      this.loadComment = true
      let formData = new FormData()
      formData.append('npa_comment[uploadedFile]', this.file)
      formData.append('npa_comment[text]', comment)
      formData.append('npa_comment[npaVersion]', this.npaData.npaVerId)
      // formData.append('npa_comment[isNpaOffer]', this.isNpaOffer)
      if (this.npaData.npaBlockId) {
        formData.append('npa_comment[npaVersionBlock]', this.npaData.npaBlockId)
      }

      Search.addNpaComment(this.npaData.npaId, formData).then((response) => {
        const {npaComment, moderation, published} = response.data

        if (npaComment.status.id === moderation) {
          this.$noty.success(this.$i18n.t('Ваш комментарий успешно отправлен и вскоре будет опубликован!'), {
            killer: true,
            timeout: 1000,
            layout: 'topRight'
          })
        } else if (npaComment.status.id === published) {
          this.npaComments.push({
            comment: npaComment,
            commentAnswers: []
          })
          let self = this
          this.npaComments.forEach(function (comment) {
            self.$set(self.menu, comment.comment.id, false)
            self.$set(self.editCommentForm, comment.comment.id, false)
          })
        }
        this.comments = []
        this.file = ''
        this.fileName = ''
        this.loadComment = false
        // this.isNpaOffer = false
      })
    },
    like(comment, flag) {
      Search.like(comment.id, {status: flag}).then((response) => {
        let result = response.data
        if (result.result == 'success') {
          if (flag) {
            comment.npa_comment_voices_like =
              response.data.comment.npa_comment_voices_like
          } else {
            comment.npa_comment_voices_dis_like =
              response.data.comment.npa_comment_voices_dis_like
          }
        } else if (result.result == 'error') {
          this.$noty.error(result.error, {
            killer: true,
            timeout: 1000,
            layout: 'topRight'
          })
        }
      })
    },
    sendComplaint(id) {
      if (this.complaint[id]) {
        Search.sendComplaint(id, {complaint: this.complaint[id]}).then(
          (response) => {
            let result = response.data
            if (result.result == 'success') {
              this.$noty.success(this.$i18n.t('Жалоба добавлена'), {
                killer: true,
                timeout: 1000,
                layout: 'topRight'
              })
            } else if (result.result == 'error') {
              this.$noty.error(result.error, {
                killer: true,
                timeout: 1000,
                layout: 'topRight'
              })
            }
          }
        )
      }

      this.complaint[id] = ''
      this.menu[id] = false
    },
    changeFile() {
      this.$refs.file.click()
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        // Валидация типа файла
        if (!this.allowedTypes.includes(file.type)) {
          this.fileError = this.$t('Неверный тип файла.');
          this.deleteFile();
          return;
        }

        // Валидация размера файла
        if (file.size > this.maxFileSize) {
          this.fileError = this.$t('Размер файла слишком большой. Максимум 50MB.');
          this.deleteFile();
          return;
        }

        // Если файл прошёл валидацию
        this.fileName = file.name;
        this.fileError = null; // Сбрасываем ошибку
        this.file = file
      }
    },
    deleteFile() {
      this.file = ''
      this.fileName = ''
      this.$refs.file.value = ''
    },
    scrollComment() {
      let query = this.query

      if (!query) return

      let selector = `#ver${query.ver}_${query.comment}`

      if (query.block) {
        selector = `#bl_${query.block}_${query.comment}`
      }
      this.$vuetify.goTo(selector)
      if (this.isLoggedIn) {
        this.setCommentRead(+query.comment)
      }
    },
    async updateCommentStatus(commentId, statusId) {
      this.loadComment = true
      const url = `${Trans.currentLocale}/api/npaComment/changeStatus/${commentId}/${statusId}`

      try {
        const {data} = await this.$http.post(url)
        const index = this.currentComments.findIndex(
          (c) => c.comment.id === commentId
        )
        if (statusId === this.deleteCommentStatusId) {
          this.currentComments.splice(index, 1)
        } else {
          const currentComment = this.currentComments.find(
            (c) => c.comment.id === commentId
          )
          currentComment.comment.status = data.commentStatus
          this.currentComments.splice(index, 1, currentComment)
        }
      } catch (error) {
        console.error(error)
      }
      this.loadComment = false
    },
    async setCommentRead(commentId) {
      const url = `${Trans.currentLocale}/api/npaComment/setRead/${commentId}`
      try {
        await this.$http.get(url)
      } catch (e) {
        console.log(e)
      }
    },
    showCommentNotice(id, show = true) {
      if (show) {
        this.$refs['commentNotice_' + id][0].classList.remove('hide')
      } else {
        this.$refs['commentNotice_' + id][0].classList.add('hide')
      }
    },
    showEditComment(id) {
      this.editCommentForm[id] = !this.editCommentForm[id]

      if (this.editCommentForm[id]) {
        const comment = this.currentComments.find(c => c.comment.id === id)?.comment
        if (comment) {
          this.$set(this.editComments, id, comment.text)
          // this.$set(this.editIsNpaOffer, id, Boolean(comment.is_npa_offer))
        }
      } else {
        this.$set(this.editComments, id, '')
        // this.$set(this.editIsNpaOffer, id, false)
      }

      this.$forceUpdate()
    },
    // updateEditIsNpaOffer(id, value) {
    //   this.$set(this.editIsNpaOffer, id, value)
    // },
    deleteCommentFile(id) {
      this.loadComment = true
      Search.deleteCommentFile(id).then((response) => {
          if (response.status === 200) {
            const npaComment = response.data.npaComment

            const index = this.currentComments.findIndex(
              (c) => c.comment.id === npaComment.id
            )
            const currentComment = this.currentComments.find(
              (c) => c.comment.id === npaComment.id
            )
            currentComment.comment = npaComment
            this.currentComments.splice(index, 1, currentComment)
          }
        this.loadComment = false
      })
        .catch((err) => {
        console.log(err)
        this.loadComment = false
      })
    },
    saveComment(id, comment) {
      if (!comment) {
        return
      }
      this.loadComment = true
      let formData = new FormData()
      formData.append('npa_comment[uploadedFile]', this.editFile[id])
      formData.append('npa_comment[text]', comment)
      // formData.append('npa_comment[isNpaOffer]', this.editIsNpaOffer[id] ? '1' : '0')

      Search.editNpaComment(id, formData).then((response) => {
          if (response.status === 200) {
            const npaComment = response.data.npaComment

            this.$noty.success(this.$i18n.t('Ваш комментарий успешно изменен!'), {
              killer: true,
              timeout: 1000,
              layout: 'topRight'
            })
            const index = this.currentComments.findIndex(
              (c) => c.comment.id === npaComment.id
            )
            const currentComment = this.currentComments.find(
              (c) => c.comment.id === npaComment.id
            )
            currentComment.comment = npaComment
            this.currentComments.splice(index, 1, currentComment)

            this.showEditComment(npaComment.id)
            this.editFile[id] = null
            this.editFileName[id] = null
            // this.editIsNpaOffer[id] = null
            this.loadComment = false
          }
      })
        .catch((err) => {
          console.log(err)
          this.loadComment = false
        })
    },
    changeEditFile(id) {
      const fileInput = this.$refs['editFile'].find(
        el => el.attributes['data-key'].value == id
      )
      fileInput.click()
    },
    handleEditFileUpload(id) {
      const fileInput = this.$refs['editFile'].find(
        el => el.attributes['data-key'].value == id
      )
      this.editFile[id] = fileInput.files[0]
      this.editFileName[id] = fileInput.files[0].name
      this.$forceUpdate()
    },
    deleteEditFile(id) {
      const fileInput = this.$refs['editFile'].find(
        el => el.attributes['data-key'].value == id
      )
      this.editFile[id] = null
      this.editFileName[id] = null
      this.$forceUpdate()
    },
    prefill(id, val) {
      this.editComments[id] = val
    }
  },
}
</script>

<style lang="scss" scoped>
ul {
  list-style: none;
  padding-left: 0;
}

.v-menu__content {
  box-shadow: none;

  .complaint-form-text {
    background: #fff;
  }
}

.pro-icon-pencil:before {
  content: "\e916";
  color: #fff;
}

.show-comment {
  display: inline-block;
  color: #fff !important;
  font-weight: 500;
  margin-left: 0;
  margin-bottom: 20px;
  background: #33a2e3;
  border-radius: 30px;
  font-size: 1.3rem;
  padding: 10px 20px;
}

.send-comment-btn {
  border-radius: 20px;
}

.attach-file-link {
  font-size: 1rem;
}
</style>
